module.exports = __webpack_public_path__ + "img/Pic_TB_E.f72a5fcf.png";